import React, { CSSProperties } from 'react'

import { ReactComponent as Ripple } from './Ripple-1.7s-160px.svg'

function Spinner(props: { style?: CSSProperties, className?: string }) {
  return <Ripple {...props} />
}

export default Spinner
